import { memo } from 'react';
import { TableRow, TableCell as TCell, TableHead as THead } from '@mui/material';
import { Typography } from '../Typography/Typography';

interface TableCell {
  label: string;
  align?: 'left' | 'center' | 'right';
  sortable?: boolean;
  maxWidth?: `${number}px`;
  minWidth?: `${number}px`;
}

export type TableHead = Record<string, TableCell>;

interface TableHeadCustomProps {
  order?: 'asc' | 'desc';
  orderBy?: string;
  tableHead: TableHead;
}

const TableHeadCustom = ({ order, orderBy, tableHead }: TableHeadCustomProps) => (
  <THead sx={{ minWidth: 800, position: 'relative' }}>
    <TableRow>
      {Object.entries(tableHead).map(([id, cell]) => {
        if (!cell) return null;

        return (
          <TCell
            key={id}
            align={cell.align || 'left'}
            sortDirection={orderBy === id ? order : false}
            sx={{
              background: 'transparent',
              padding: '0px 8px',
              maxWidth: cell.maxWidth,
              minWidth: cell.minWidth,
              height: `56px`,

              '&:first-of-type': {
                paddingLeft: '16px',
              },

              '&:last-of-type': {
                paddingRight: '16px',
              },
            }}
          >
            <Typography component="p" fontWeight={600} fontSize="0.875rem" lineHeight="24px"> 
              {cell.label}
            </Typography>
          </TCell>
        );
      })}
    </TableRow>
  </THead>
);

export const TableHeadCustomMemo = memo(TableHeadCustom);
